// extracted by mini-css-extract-plugin
export var active = "_2v-d";
export var blink = "_2v-e";
export var container = "_2v-5";
export var controls = "_2v-0";
export var controlsRight = "_2v-1";
export var fakeCursor = "_2v-c";
export var hidden = "_2v-b";
export var quillContainerSmall = "_2v-7";
export var quillEditor = "_2v-6";
export var quillEditorSmall = "_2v-8";
export var quillFormatButtons = "_2v-a";
export var quillToolbar = "_2v-9";
export var removePadding = "_2v-2";
export var state = "_2v-3";
export var stateTitle = "_2v-4";